// This file is auto-generated don't edit it!
import { Component } from '@angular/core';

@Component({
    selector: 'ui-svg-icon-docs',
    templateUrl: './svg-icon.docs.generated.html',
})
export class UISvgIconDocs { }
